import { render, staticRenderFns } from "./DashboardRedemption.vue?vue&type=template&id=fa5114b6&"
import script from "./DashboardRedemption.vue?vue&type=script&lang=js&"
export * from "./DashboardRedemption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports